/* eslint-disable no-nested-ternary */
// import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import moment from "moment";
import {
  ALL_DATES,
  // INTEGER_KEYS,
  AppliedFilterFriendLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../../contants";
import { ROUTES } from "../../../utils/constants";
import { isEmptyObj, isOSKey } from "../../../utils/helper";

// const DATE_FORMAT = "yyyy-MM-dd";
const PLUS = "plus";
// const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "positions";
export const MAINLINE_POSITION_KEY = "mainlinePositions";
export const DIVISION_KEY = "divisionIds";
export const MEETING_TYPE = "meetingType";
export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getRoutePath = () => ROUTES.REPORTS_ATTENDANCE.path;

const handlePositions = (queryObject, currObj, key) => {
  const currentPositions = currObj[POSITIONS_KEY] ?? [];

  const keyValue = queryObject[key]
    ? queryObject[key].split(",").map(Number)
    : [];

  return [...currentPositions, ...keyValue];
};

const handleOS = (queryObject, currObj, key) => {
  // const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    // [OS_LABEL]: currentOS,
    [key]: Number(queryObject[key]),
  });
};
const DIVISION_OPTIONS = [
  {
    value: "1",
    entityTitle: "MD",
  },
  {
    value: "2",
    entityTitle: "WD",
  },
  {
    value: "37",
    entityTitle: "YMD",
  },
  {
    value: "3",
    entityTitle: "YWD",
  },
];

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];
        const key =
          currKey === MAINLINE_POSITION_KEY
            ? POSITIONS_KEY
            : currKey === MEETING_TYPE
            ? MEETING_TYPE
            : currKey;

        if (ALL_DATES.includes(currKey)) {
          value = queryObject[currKey];
        } else if (MEETING_TYPE.includes(currKey)) {
          value = queryObject[currKey];
        } else if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(currKey)) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        }
        return Object.assign(acc, {
          [key]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    // console.log(curr);
    console.log(queryObject[curr], curr);
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        const startDate = moment(queryObject[curr]).format("DD-MMM-YYYY");
        const endDate = moment(queryObject[`${key}To`]).format("DD-MMM-YYYY");
        acc.push({
          key: curr,
          displayName: "Period",
          value: `${startDate} - ${endDate}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // if ([DATE_FROM, DATE_TO].includes(curr)) {
      //   const key = curr;
      //   console.log("key", key);

      //   const valueMap = keyBy("value", metaData.attendanceDate);
      //   console.log("valueMap", valueMap);
      //   acc.push({
      //     key: curr,
      //     displayName: AppliedFilterFriendLabelMap[key],
      //     value: valueMap,
      //     disabled: disabledOSKeys.includes(curr),
      //   });
      // }
      if (MEETING_TYPE.includes(curr)) {
        const key = curr;
        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[key],
          value: queryObject[curr].replace(/_/g, " "),
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
          : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

        console.log("pool", pool);

        const selectedValue = pool.find(
          (p) =>
            (p.structureId || p.divisionId || p.cityId || p.stateId) ===
            // p.periodDate
            Number(queryObject[curr])
        );
        console.log("pool", pool);

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value:
            selectedValue?.name ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            // selectedValue?.attendanceDate ||
            queryObject[curr],
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }
      if (curr === DIVISION_KEY) {
        const divisionId = queryObject[curr];
        const selectedDivisions = divisionId
          .split(",")
          .map((id) => {
            const division = DIVISION_OPTIONS.find(
              (option) => option.value === id
            );
            return division ? division.entityTitle : null;
          })
          .filter(Boolean);
        console.log("line 193", selectedDivisions);
        acc.push({
          key: curr,
          displayName: AppliedFilterFriendLabelMap[curr],
          value: selectedDivisions.join(", "),
        });
        return acc;
      }
      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterFriendLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.clusterId;
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.clusterId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subdivisionId;
  }

  return updatedQueryWithOS;
};
